/* eslint-disable prefer-destructuring */
import cookie from '@/common/cookie';
import get from 'lodash/get';
import { DefaultLogger } from '@/common/logger';
import { cardStyleMap } from '@/common/const';

const bTypeMap = {
  vipmodule: 18, // 视频vip模块
  sport: 19, // 体育vip模块
  other: 20, // 其他套餐模块
  integral: 4, // 积分
  diamonds: 2, // 钻石
  iconInfo: 13, // vip等级大图标
  vipIcon: 12, // 身份位角标
  identity: 17, // 会员身份信息
};


/**
 * 解析规则：
 * bid_type:
 * 0    // 视频HVIP
 * 3    // 视频SVIP
 * 3002 // 体育VIP
 * 3006 // 追剧月卡
 * 3010 // JUMP学生卡
 * 3011 // JUMP卡
 * 3012 // 家庭套餐
 * 4002 // vip附属卡
 * 4003 // svip附属卡
 * 3013 // 短剧卡
 *
 *
 * status:
 * 0 // 从未开过，不下发
 * 1 // 当前会员有效
 * 2 // 当前会员过期
 *
 * end_time： 会员截止时间戳
 * status=1时为到期时间
 * status=2时为过期时间
 */
const identityMap = {
  vip: 0,
  sVip: 3,
  sportVip: 3002,
  familySub: 3012,
  jump: 3010,
  jumpAttach: 3011,
};

interface VipIcon {
  bid: number;
  pic: string;
}

interface ActionObj {
  reportKey: string;
  reportParams: string;
  url: string;
}

interface VipInfo {
  is_family_role_sub: boolean;
  list: [];
}

interface ElementReport {
  elementId: string;
  elementParams: string;
}

const statusMap = {
  noVip: 0, // 未开过
  vip: 1, // 当前会员有效
  expired: 2, // 当前会员过期
};
interface UserCardModule {
  vip_level_big_icon: any;
  title: string;
  subtitle: string;
  subTitle: string;
  darkTitleColor: string;
  dark_title_color: string;
  bType: number;
  vip_icon_list: VipIcon[];
  vip_info_list: VipInfo;
  pc_button_text: string;
  pc_background_image: string;
  elementReport: ElementReport;
  action: ActionObj;
}

// 优先级svip（bid=3）>svip附属卡（bid=4003）>hvip(bid=0)>hvip附属卡（bid=4002)
const vipBidMap = {
  svip: 3,
  svipAttach: 4003,
  hvip: 0,
  hvipAttach: 4002,
};

// 优先级家庭（bid=3012)>jump(bid=3011)>短剧卡(bid=3013)
const otherBidMap = {
  home: 3012,
  jump: 3011,
  short: 3013,
};

let cookies = {};

const getReportObj = (elementParams: string) => {
  const result = {};
  if (elementParams) {
    const reportObj = elementParams.split('&');
    if (reportObj && reportObj.length > 0) {
      reportObj.forEach((item: any) => {
        if (item && item.indexOf('=') > 0) {
          const temp = item.split('=');
          const key = temp[0].trim() as string;
          // @ts-ignore
          result[key] = temp[1].trim();
        }
      });
    }
  }
  return result;
};

export default class UserCard {
  public modulelist = [] as UserCardModule[];
  public vipCard = {};
  public sportCard = {};
  public integralInfo = {};
  public diamondsInfo = {};
  public otherCard = {};
  public iconInfo = {};
  public userbasicReportInfo = {};
  public vipIconList: Record<string, unknown>[] = [];
  public userIdentity = '';
  public isFVip = false;
  public cardStyle = {};

  constructor(modules: UserCardModule[]) {
    if (!modules?.length) {
      return;
    }
    this.modulelist = modules.map(module => ({
      title: module.title,
      subTitle: module.subtitle,
      buttonText: module.pc_button_text,
      bType: module.bType,
      vip_icon_list: module.vip_icon_list,
      vip_level_big_icon: module.vip_level_big_icon,
      elementParams: module.elementReport?.elementParams,
      actionUrl: module.action?.url,
    }));

    this.initCommonCard();
    this.initVipIconList();
    this.initOtherModule(modules);
    this.initIdentity(modules);
  }

  async initCommonCard() {
    cookies = await cookie.toJSON();
    // 赋值基础上报信息
    this.userbasicReportInfo = {
      mod_id: 'mod_profile_new',
      pgid: 'page_home_channel',
      vcuid: get(cookies, 'vqq_vuserid', '') || get(cookies, 'vuserid', '') || '',
      vcuid_name: get(cookies, 'qq_nick', '') || get(cookies, 'wx_nick', '') || '',
    };

    this.vipCard = this.filterModuleByType(bTypeMap.vipmodule, 'tv-vip');
    this.sportCard =  this.filterModuleByType(bTypeMap.sport, 'sport');
    this.integralInfo = this.filterModuleByType(bTypeMap.integral, 'score');
    this.diamondsInfo = this.filterModuleByType(bTypeMap.diamonds, 'diamond');
  }

  filterModuleByType(bTypeParams: number, title: string) {
    const filterResult = this.modulelist.find(module => module.bType === bTypeParams) || {};

    // @ts-ignore
    const elementReportObj = getReportObj(filterResult.elementParams);
    filterResult.elementData = {
      title,
      ...elementReportObj,
    };

    return filterResult;
  }

  initVipIconList() {
    // eslint-disable-next-line max-len
    const vipIconList =  (this.modulelist.filter(module => module.bType === bTypeMap.vipIcon)[0] || []);
    this.vipIconList = vipIconList?.vip_icon_list
    // 获取等级图标
    const vipBigIcon = this.modulelist.filter(module => module.bType === bTypeMap.iconInfo)[0];
    const vipIcon = this.getSvip() || this.getSvipAttach() || this.getHvip() || this.getHvipAttach();
    const otherIcon = this.getHome() || this.getJump() || this.getShort();
    this.iconInfo = {
      vipIcon,
      otherIcon,
      vipBigIcon: vipBigIcon?.vip_level_big_icon,
    };
  }
  /**
   *
   * @param modules const identityMap =
   * {
   *  noVip: 'no_vip',
   *  vip: 'vip',
   *  svip: 'svip',
   *  sportVip: 'sport_vip',
   *  studentVip: 'student_novip'
   *  };
   * @returns string
   */
  initIdentity(modules: UserCardModule[]) {
    const identityInfo = modules.find(module => module.bType === bTypeMap.identity);
    const customInfo = modules.find(module => module.bType === bTypeMap.other);
    const identityInfoList = identityInfo?.vip_info_list?.list || [];
    const isFamilyRoleSub = identityInfo?.vip_info_list.is_family_role_sub || false;
    if (!identityInfoList.length) {
      this.userIdentity = 'no_vip';
      this.cardStyle = cardStyleMap.noVip;
      return;
    }
    const isSvip = identityInfoList.find(item => item.bid_type === identityMap.sVip && item.status);
    const isVip = identityInfoList.find(item => item.bid_type === identityMap.vip && item.status);
    const isSportVip = identityInfoList.find(item => item.bid_type === identityMap.sportVip && item.status);
    const isFamilyRole = identityInfoList.find(item => item.bid_type === identityMap.familySub);
    const isStudent = customInfo?.pc_background_image || '';
    const isJump = identityInfoList.find(item => item.bid_type === identityMap.jump && item.status);
    const isJumpAttach = identityInfoList.find(item => item.bid_type === identityMap.jumpAttach && item.status);
    DefaultLogger.log('model/userCard', isStudent);
    this.isFVip = !!isFamilyRole?.status;
    if (isSvip) {
      this.userIdentity = 'svip';
    } else if (isVip) {
      this.userIdentity = 'vip';
    } else if (isSportVip) {
      this.userIdentity = 'sport_vip';
    } else if (isStudent) {
      this.userIdentity = 'student_novip';
    } else if (isFamilyRole && isFamilyRoleSub) {
      this.userIdentity = 'family_sub';
    } else {
      this.userIdentity = 'no_vip';
    }
    const isSvipExpire = identityInfoList.find(item => item.bid_type === identityMap.sVip && item.status === statusMap.expired);
    const isVipExpire = identityInfoList.find(item => item.bid_type === identityMap.vip && item.status === statusMap.expired);

    if (isFamilyRole || isFamilyRoleSub) {
      this.cardStyle = cardStyleMap.family;
    } else if (isJump || isJumpAttach) {
      this.cardStyle = cardStyleMap.jump;
    } else if (isSvip) {
      this.cardStyle = cardStyleMap.svipAndShortAndFamily;
    } else if (isVip) {
      this.cardStyle = cardStyleMap.vipAndSportAndFamily;
    } else if (isSportVip) {
      this.cardStyle = cardStyleMap.sportAndFamily;
    } else if (isSvipExpire) {
      this.cardStyle = cardStyleMap.svipExpired;
    } else if (isVipExpire) {
      this.cardStyle = cardStyleMap.vipExpired;
    } else {
      this.cardStyle = cardStyleMap.noVip;
    }
  }

  initOtherModule(modules: UserCardModule[]) {
    const customInfo = modules.find(module => module.bType === bTypeMap.other) || {
      title: '',
      subtitle: '',
      pc_button_text: '',
      bType: 0,
      pc_title_color: '',
      pc_subtitle_color: '',
      pc_button_color: '',
      pc_button_text_color: '',
      pc_background_image: '',
      elementReport: { elementParams: '' },
      action: { url: '' },
    };
    // @ts-ignore
    const elementReportObj = getReportObj(customInfo.elementReport?.elementParams);
    this.otherCard = {
      // 定制文案
      title: customInfo.title,
      subTitle: customInfo.subtitle,
      buttonText: customInfo.pc_button_text,
      bType: customInfo.bType,
      // 定制背景图
      actionUrl: customInfo.action?.url || '',
      elementData: {
        title: 'other',
        ...elementReportObj,
      },
    };
  }

  getSvip() {
    return this.getIconByBid(vipBidMap.svip);
  }
  getSvipAttach() {
    return this.getIconByBid(vipBidMap.svipAttach);
  }
  getHvip() {
    return this.getIconByBid(vipBidMap.hvip);
  }
  getHvipAttach() {
    return this.getIconByBid(vipBidMap.hvipAttach);
  }

  getIconByBid(bidVal: number) {
    return this.vipIconList.find((item: VipIcon) => item.bid === bidVal)?.pic || '';
  }

  getHome() {
    return this.getIconByBid(otherBidMap.home);
  }
  getJump() {
    return this.getIconByBid(otherBidMap.jump);
  }
  getShort() {
    return this.getIconByBid(otherBidMap.short);
  }
}
